class PlanLabel extends HTMLElement {
  constructor() {
    super();

    // Open status
    this.open = false;

    // Setup elements
    this.toggle = this.querySelector('[data-toggle]');
    this.toggleWrap = this.querySelector('[data-toggle-wrap]');
    this.content = this.querySelector('[data-content]');
    this.renewalToggle = this.querySelector('[data-renewal-toggle]');
    this.renewalLabels = this.querySelectorAll('[data-renewal-label]');

    // Bind event handlers
    this.toggle.addEventListener('click', this.handleToggle.bind(this));

    if (this.renewalToggle) {
      this.renewalToggle.addEventListener('change', this.handleRenewalChange.bind(this));
    }
  }

  handleRenewalChange(e) {
    const renewal = e.target.value;

    this.renewalLabels.forEach((label) => {
      label.classList.toggle('hidden', label.dataset.renewalLabel !== renewal);
    });

    this.open = true;
    this.updateVisibility();
  }

  handleToggle() {
    this.open = !this.open;
    this.updateVisibility();
  }

  updateVisibility() {
    this.content.classList.toggle('max-h-96', !this.open);
    this.content.classList.toggle('max-h-[10000px]', this.open);
    this.toggleWrap.classList.toggle('hidden', this.open);
  }
}

customElements.define('plan-label', PlanLabel);
